<template>
  <div>
    <h2>Cytaty</h2>
    <el-card class="box-card text" v-for="(quote, index) in quotes" :key="index">
        <q v-html="renderText(quote)"></q>
        <div class="buttons">
          <el-button type="success" @click="createText(quote)" size="mini">Dodaj</el-button>
          <el-button type="primary" @click="setText(quote)" size="mini">Wybieram</el-button>
        </div>
    </el-card>
  </div>
</template>

<script>
  import Editor from '../../classes/Editor'

  export default {
    data() {
      return {
        quotes: [
          'Gdy Cię pierwszy raz ujrzałam wierzyłam,\nże mi serce dasz, lecz nigdy nie przypuszczałam,\nże to tak długo będzie trwać.',
          'Żyję miłością dla Ciebie, uśmiechem, uściskiem, spojrzeniem,\nsnem o Twej jasnej postaci i cichym, długim marzeniem. ',
          '"Tyś szczęście moje wiosenne, letnie, zimowe, jesienne,\nlecz powiedz mi na dobranoc, wyszeptaj przez usta senne.\nZa cóż to taka zapłata, ten raj przy Tobie tak błogi?\nTy jesteś światłem świata i pieśnią mej drogi."\n\nK. I. Gałczyński',
          'Rękę Ci daję, Miłość  Ci daję cenniejszą niż pieniądz.\nCzy Ty dasz mi siebie? Powędrujesz ze mną?\nSiebie Ci daję, zanim to potwierdzi kaznodzieja bądź prawo.\nCzy Ty dasz mi siebie? I czy trwać będziemy - ja przy Tobie,\nTy przy mnie - dopóki żyjemy?” Walt Whitman',
          '"Nowi ludzie ... Dotąd Dwoje, lecz jeszcze nie Jedno,\nOdtąd Jedno, chociaż nadal Dwoje”\n\nK. Wojtyła',
          '"Żaden dzień się nie powtórzy, nie ma dwóch podobnych nocy,\ndwóch tych samych pocałunków, dwóch jednakich spojrzeń w oczy...\nsą na siebie skazani."\n\nW. Szymborska',
          '"Jedną z najstarszych ludzkich potrzeb jest mieć kogoś,\nkto zastanawia się, gdzie jesteśmy kiedy nie wracamy wieczorem do domu."\n\nMargaret Mead',
        ]
      };
    },
    methods: {
      setText(quote) {
        if (! Editor.canvas.getActiveObject()) {
          this.$alert('Wybierz pole tekstowe w którym wstawić wybrany tekst.', 'Ups...', {
            confirmButtonText: 'OK',
            type: 'warning',
          });
        } else {
          Editor.setText(quote);
        }
      },
      createText(text) {
        Editor.addText(text, {
          textAlign: 'center',
          fontSize: 16,
          width: 400
        });
      },
      renderText(text) {
        return text.replace(/\\n/g, '<br />');
      }
    }
  }
</script>

<style lang="less">
  .box-card {
    &.text {
      .el-card__body {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .buttons {
        margin-top: 15px;
      }
      + .text {
        margin-top: 15px;
      }
      q {
        width: 100%;
        font-size: 10px;
        text-align: center;
      }
    }
  }
</style>